module.exports = __webpack_public_path__ + "static/media/icon-erase-blue.c75bb05b.svg";